import { compose, withProps } from 'recompose';

import JobForm from './JobForm';

const mapDataToProps = withProps((props) => {
  const { lookup: leLookup } = props.job.lease;
  const { lookup: opLookup } = props.job.lease.operator;
  const initialValues = {
    lease: leLookup,
    operator: opLookup,
  };

  return {
    initialValues,
  };
});

const enhance = compose(mapDataToProps);

export default enhance(JobForm);
